import React from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/async/withScriptjs';

import { getIconOptions, isIconOptimized } from 'components/MarkerSettings/IconOptions';
import { roundLatLng } from 'utils/maps';
import SnazzyInfoWindow from 'components/Shared/SnazzyInfoWindow';
import { PANELS } from 'modules/navigation/activePanel';

const handleMarkerDragEnd = (e, marker, callback) => {
    callback(marker.id, roundLatLng(e.latLng));
};

const SnazzyMap = withScriptjs(
    withGoogleMap(
        ({
            center,
            zoom,
            onClick,
            onPan,
            onLoad,
            onZoom,
            options,
            markers,
            activeMarker,
            activePanel,
            onMarkerDragEnd,
            onMapTypeChange,
        }) => {
            const isActive = (marker) => activeMarker && marker && activeMarker.id === marker.id;
            const noop = () => {};
            return (
                <GoogleMap
                    ref={onLoad || noop}
                    zoom={zoom}
                    center={center}
                    onDragEnd={onPan || noop}
                    onZoomChanged={onZoom || noop}
                    onClick={onClick || noop}
                    onMapTypeIdChanged={onMapTypeChange || noop}
                    options={options}
                >
                    {markers &&
                        markers.map((marker) => (
                            <Marker
                                draggable={isActive(marker) && activePanel === PANELS.MARKER}
                                zIndex={isActive(marker) ? 99999999 : 0}
                                opacity={!activeMarker || isActive(marker) ? 1 : 0.5}
                                key={marker.id}
                                position={marker.location}
                                icon={getIconOptions(marker.icon)}
                                options={{
                                    optimized: isIconOptimized(marker.icon),
                                }}
                                onDragEnd={(e) => handleMarkerDragEnd(e, marker, onMarkerDragEnd)}
                            >
                                {marker.infoWindow.enabled && (
                                    <SnazzyInfoWindow {...marker.infoWindow} onLocationChange={onPan || noop} />
                                )}
                            </Marker>
                        ))}
                </GoogleMap>
            );
        }
    )
);

const Map = (props) => {
    return (
        <SnazzyMap
            {...props}
            // TODO: Create a real loading indicator?
            loadingElement={<div />}
            containerElement={<div style={{ height: '100%' }} />}
            mapElement={<div style={{ height: '100%' }} />}
        />
    );
};

export default Map;
